import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/list.svg")